import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const EducationStep = ({ formData, errors, onChange }) => {
  const degreeOptions = [
    { value: 'bsc', label: 'B.Sc. (Bachelor of Science)' },
    { value: 'ba', label: 'B.A. (Bachelor of Arts)' },
    { value: 'beng', label: 'B.Eng. (Bachelor of Engineering)' },
    { value: 'btech', label: 'B.Tech. (Bachelor of Technology)' },
    { value: 'msc', label: 'M.Sc. (Master of Science)' },
    { value: 'ma', label: 'M.A. (Master of Arts)' },
    { value: 'meng', label: 'M.Eng. (Master of Engineering)' },
    { value: 'phd', label: 'Ph.D. (Doctor of Philosophy)' },
    { value: 'hnd', label: 'HND (Higher National Diploma)' },
    { value: 'ond', label: 'OND (Ordinary National Diploma)' }
  ];

  const classOfDegreeOptions = [
    { value: 'first-class', label: 'First Class Honours' },
    { value: 'second-class-upper', label: 'Second Class Honours (Upper Division)' },
    { value: 'second-class-lower', label: 'Second Class Honours (Lower Division)' },
    { value: 'third-class', label: 'Third Class Honours' },
    { value: 'pass', label: 'Pass' },
    { value: 'distinction', label: 'Distinction' },
    { value: 'upper-credit', label: 'Upper Credit' },
    { value: 'lower-credit', label: 'Lower Credit' }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-white text-lg">🎓</span>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-1">Educational Background</h3>
            <p className="text-sm text-gray-600">
              Tell us about your educational qualifications and academic achievements.
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6">
        <Input
          label="Institution Name"
          type="text"
          value={formData?.institutionName}
          onChange={(e) => onChange('institutionName', e?.target?.value)}
          error={errors?.institutionName}
          required
          placeholder="Enter your university/institution name"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Select
            label="Degree Type"
            options={degreeOptions}
            value={formData?.degreeType}
            onChange={(value) => onChange('degreeType', value)}
            error={errors?.degreeType}
            required
            searchable
            placeholder="Select degree type"
          />

          <Input
            label="Course of Study"
            type="text"
            value={formData?.courseOfStudy}
            onChange={(e) => onChange('courseOfStudy', e?.target?.value)}
            error={errors?.courseOfStudy}
            required
            placeholder="e.g., Computer Science"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Input
            label="Year of Graduation"
            type="number"
            value={formData?.graduationYear}
            onChange={(e) => onChange('graduationYear', e?.target?.value)}
            error={errors?.graduationYear}
            required
            placeholder="e.g., 2024"
            min="1980"
            max="2025"
          />

          <Select
            label="Class of Degree"
            options={classOfDegreeOptions}
            value={formData?.classOfDegree}
            onChange={(value) => onChange('classOfDegree', value)}
            error={errors?.classOfDegree}
            required
            placeholder="Select class"
          />

          <Input
            label="CGPA/Grade"
            type="text"
            value={formData?.cgpa}
            onChange={(e) => onChange('cgpa', e?.target?.value)}
            error={errors?.cgpa}
            required
            placeholder="e.g., 4.50/5.00"
          />
        </div>
      </div>
      <div className="border-t border-gray-200 pt-6">
        <div className="flex justify-between items-center mb-4">
          <h4 className="text-md font-semibold text-gray-900">Professional Certifications</h4>
          <Button
            variant="outline"
            size="sm"
            iconName="Plus"
            iconPosition="left"
          >
            Add Certification
          </Button>
        </div>
        <Input
          label="Certification Name"
          type="text"
          value={formData?.certificationName}
          onChange={(e) => onChange('certificationName', e?.target?.value)}
          placeholder="e.g., AWS Certified Solutions Architect (optional)"
          description="Add any relevant professional certifications"
        />
      </div>
    </div>
  );
};

export default EducationStep;